export const FEATURE_NAME = 'standings'
